export default {
  "content": "<path fill=\"#000\" d=\"M4.225.553A.999.999 0 015.119 0H8.88a1 1 0 01.894.553L10 1h3a1 1 0 110 2H1a1 1 0 010-2h3zM.972 4H13v10c0 1.103-.897 2-2 2H2.972c-1.077 0-2-.897-2-2zm2.5 2.5v7c0 .275.253.5.5.5.303 0 .5-.225.5-.5v-7c0-.275-.197-.5-.5-.5a.52.52 0 00-.5.5zm3 0v7c0 .275.253.5.5.5.303 0 .528-.225.528-.5v-7c0-.275-.225-.5-.528-.5a.52.52 0 00-.5.5zm3.028 0v7c0 .275.225.5.5.5s.5-.225.5-.5v-7c0-.275-.225-.5-.5-.5s-.5.225-.5.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 14 16"
  }
};